import Glide, { Breakpoints, Controls, Swipe } from '@glidejs/glide/dist/glide.modular.esm';

const defaultOptions = {
    type: 'carousel',
    perView: 3,
    gap: 30,
    breakpoints: {
        568: {
            perView: 1,
        },
        768: {
            perView: 1,
        },
        992: {
            perView: 2,
        },
        1200: {
            perView: 3,
        },
        1400: {
            perView: 4,
        },
    },
};

class Slider {
    _root: HTMLElement;
    _glide: Glide;
    _options: any;

    constructor( root: HTMLElement ) {
        this._root = root;

        this._options = Object.assign( {}, defaultOptions, this._root.dataset );

        this._glide = new Glide( this._root, this._options );

        this._glide.mount( {
            Breakpoints,
            Controls,
            Swipe,
        } );
    }
}

export default Slider;
